import { Component, effect, OnDestroy, inject, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { NavComponent } from '@shared/components/nav-list/nav.component';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { AuthService } from '@core/services/auth.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MenuService } from '@shared/services/menu.service';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, HeaderComponent, NavComponent, LoadingComponent, MatSidenavModule],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent implements OnDestroy, OnInit {
  private _authService = inject(AuthService);
  private router = inject(Router);
  readonly menuType = signal<'over' | 'side'>('side');
  breakpointObserver = inject(BreakpointObserver);
  menuService = inject(MenuService);
  isUserLogin: boolean = false;
  private readonly mobileQuery = 'screen and (max-width: 599px)';
  private readonly tabletQuery = 'screen and (min-width: 600px) and (max-width: 1023px)';

  authenticated = effect(() => {
    this.isUserLogin = this._authService.isUserLoginSig();
  });

  ngOnInit(): void {
    this.breakpointObserver.observe([this.mobileQuery, this.tabletQuery]).subscribe((state: BreakpointState) => {
      const isMobileOrTablet = state.breakpoints[this.mobileQuery] || state.breakpoints[this.tabletQuery];
      this.menuType.set(isMobileOrTablet ? 'over' : 'side');
      this.menuService.showMenu.set(!isMobileOrTablet);
      this.menuService.menuType = this.menuType();
    });

    setTimeout(() => {
      if (!this.isUserLogin) {
        this.router.navigate(['/auth']);
      }
    }, 100);
  }

  ngOnDestroy(): void {
    this.authenticated && this.authenticated.destroy();
  }
}
